<template>
<div style="background-color: lightgray">
  <van-row>
    <van-col span="24">
      <van-cell-group>
        <van-field
            v-model="detailData.plateformName"
            label="平台:"
            placeholder="淘宝会员名"
            :rules="[{ required:true, message: '请输入正确内容' }]"
            input-align="right"
            readonly
        />
        <van-field
            v-model="detailData.plateformUsername"
            label="平台会员名:"
            placeholder="淘宝会员名"
            :rules="[{ required:true, message: '请输入正确内容' }]"
            input-align="right"
            readonly
        />
        <van-field
            v-if="detailData.taoValue"
            v-model="detailData.taoValue"
            label="淘气值:"
            placeholder="0"
            :rules="[{ required:true, message: '请输入正确内容' }]"
            input-align="right"
            readonly
        />
          <van-field
              v-if="detailData.plateformSerNum == '1'"
              readonly
              clickable
              name="picker"
              label="账号等级"
              placeholder="无"
              input-align="right"
          >
            <template #input>
              <div v-if="accountLeave.id == 0">
                无
              </div>
              <div v-if="accountLeave.id == 1">
                <i class="A"  v-for="i in accountLeave.diamondsLevel">
                </i>
              </div>
              <div v-if="accountLeave.id == 2">
                <i class="B"  v-for="i in accountLeave.diamondsLevel">
                </i>
              </div>
              <div v-if="accountLeave.id == 3">
                <i class="C"  v-for="i in accountLeave.diamondsLevel">
                </i>
              </div>
              <div v-if="accountLeave.id == 4">
                <i class="D"  v-for="i in accountLeave.diamondsLevel">
                </i>
              </div>
            </template>
          </van-field>
        <van-field v-if="detailData.plateformSerNum=='1'" readonly label="是否开通花呗:" input-align="right" label-width="100" v-model="detailData.aliyunPay==='true'?'是':'否'"/>
        <van-field readonly label="性别:" input-align="right" v-model="detailData.plateformSex==='true'?'男':'女'">
        </van-field>
        <van-field
            readonly
            v-model="detailData.plateformAge"
            label="年龄:"
            placeholder="请填写年龄"
            :rules="[{ required:true, message: '请输入正确内容' }]"
            input-align="right"
        />
        <van-field
            v-if="detailData.orderNum"
            readonly
            v-model="orderEndNum"
            label="订单后6位:"
            placeholder="请复制该淘宝会员任意一个订单号"
            :rules="[{ required:true, message: '请输入正确内容' }]"
            input-align="right"
        />
        <div>
        </div>
        <van-field
            readonly
            clickable
            label="收货地区:"
            :value="detailData.expressAddr"
            placeholder="请选择地区"
            is-link
            input-align="right"
        />
        <van-field
            readonly
            v-model="detailData.addressDetail"
            placeholder="收货详细地址"
            :rules="[{ required:true, message: '请输入正确内容' }]"
            input-align="right"
        />
      </van-cell-group>
      <div v-if="detailData.imageUrl">
      <van-row gutter="0">
        <van-col span="24">
          <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller">
            <span style="margin-left: 5%;">注意事项</span>
          </div>
          <van-field readonly >
            <template #input>
              按照提示绑号即可
            </template>
          </van-field>
        </van-col>
      </van-row>
      <van-row gutter="0" style="background-color: white">
        <div style="margin: 2%;padding-top: 2%;">
          <van-col span="11" >
            <van-image
                @click="perviewImage(detailData.imageUrl)"
                :src="detailData.imageUrl"></van-image>
          </van-col>
          <van-col span="2">
            <div style="padding: 16px 6px 1px;margin-left: 12px;border-left: 1px solid;font-size: 0;height: 210px;"></div>
          </van-col>
          <van-col span="11">
            <van-image
                @click="perviewImage(imageIdCard)"
                :src="imageIdCard" v-if="detailData.plateformSerNum == '1'"></van-image>
            <van-image
                @click="perviewImage(imageDyUrl)"
                :src="imageDyUrl" v-else></van-image>
          </van-col>
        </div>
      </van-row>
      </div>
    </van-col>
  </van-row>
</div>
</template>

<script>
import {getPlateformAccount} from "../../api/system/sys_plateform";
import {MessageBox} from "mint-ui";
import {ImagePreview} from "vant";

export default {
  name: "BrowsePlateformInfo",
  data(){
    return {
      detailData:{},
      accountLeave: {},
      imageIdCard:"https://myb2c.oss-cn-hangzhou.aliyuncs.com/admin/image3.jpg",
      imageDyUrl:"https://myb2c.oss-cn-hangzhou.aliyuncs.com/admin/image0.jpg"
    }
  },
  computed:{
    orderEndNum:function () {
        let str = this.detailData.orderNum;
        return this.detailData.orderNum.substring(str.length-6);
      }
  },
  mounted() {
    this.$emit("titleChange", "账号信息");
    getPlateformAccount(this.$route.query.id).then(res=>{
      if (res.success){
        this.detailData = res.data;
        this.accountLeave = res.data.accountLeave;
        console.log(this.accountLeave)
      }
    }).catch(err => {
      MessageBox({
        title: '提示',
        message: err.message,
        showCancelButton: true
      });
    });
  },
  methods:{
    perviewImage(imgUrl){
      ImagePreview({
        images: [
          imgUrl
        ],
        closeable: true,
      });
    },
  }
}
</script>

<style lang="scss" scoped>
i.A {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-image: url(../../assets/img/A.gif);
  background-position: center center;
  background-repeat: no-repeat;
  display: inline-block;
}

i.B{
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-image: url(../../assets/img/B.gif);
  background-position: center center;
  background-repeat: no-repeat;
  display: inline-block;
}

i.C{
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-image: url(../../assets/img/C.gif);
  background-position: center center;
  background-repeat: no-repeat;
  display: inline-block;
}


i.D{
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-image: url(../../assets/img/D.gif);
  background-position: center center;
  background-repeat: no-repeat;
  display: inline-block;
}
</style>
